// extracted by mini-css-extract-plugin
module.exports = {"heading":"Approvers_heading__1pm1h","mainHeadline":"Approvers_mainHeadline__1pkBp","mainContentTitle":"Approvers_mainContentTitle__2sy6i"};